import React from 'react';
import { Reveal } from './Reveal';
import { costs } from '../data/offer';
export function CostOfNotBuying() {
  return <section className="w-full bg-surface px-4 py-20 text-navy sm:py-24" data-id="element-46" data-mp="1203twhd2lncy">
      <Reveal className="mx-auto max-w-4xl text-center" data-id="element-47" data-mp="16zyn4rkbip16">
        <h2 className="font-serif text-4xl leading-tight sm:text-5xl" data-id="element-48" data-mp="16ydooquvuly1">
          ⏳ Il vero costo di <span className="text-amber" data-id="element-49" data-mp="1b1abyuvdb68b">non agire</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-slate" data-id="element-50" data-mp="ecvntx7tia9v">
          Continuare senza una struttura chiara può significare rimandare ancora la comprensione di schemi che desideri
          esplorare.
        </p>
        <div className="mx-auto mt-10 max-w-2xl space-y-5 text-left" data-id="element-51" data-mp="nbpj9k9ewulu">
          {costs.map(([title, description]) => <div key={title} className="border-b border-navy/10 pb-5" data-id="element-52" data-mp="s5bwpeneh2ip">
              <h3 className="font-semibold text-navy" data-id="element-53" data-mp="3rpxoujars1vc">{title}</h3>
              <p className="mt-2 text-sm leading-6 text-slate" data-id="element-54" data-mp="3vrsprmosgd8l">{description}</p>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl italic leading-relaxed text-amber sm:text-3xl" data-id="element-55" data-mp="3uvcegnnvu2hc">
          «&nbsp;Il tuo prossimo capitolo può essere identico all’ultimo.
          <br data-id="element-56" data-mp="3l6b35asa899p" />
          O può essere il primo con un vero sistema.&nbsp;»
        </p>
      </Reveal>
    </section>;
}